<template>
    <div>

         <CoolLightBox 
            :items="filmes" 
            :index="index"
            @close="index = null">
        </CoolLightBox>
        
        <Navbar :forceBg="true" />
        <section id="catalogo" class="conteudo">
            
            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <h1>Novidades de Dezembro</h1>
                        <h4>Confira abaixo, as novidades do nosso Catálogo no mês de Dezembro de 2020:</h4>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-3 col-6" v-for="(filme, filmeIndex) in filmes" :key="filmeIndex">
                        <img :src="filme" class="catalogo-filme" @click="index = filmeIndex">
                    </div>

                </div>


            </div>
            
        </section>
        <Footer />
    </div>
</template>

<style scoped>

img{
    max-width: 100%;
    height: auto;
    margin-bottom: 25px;
    cursor: pointer;
}

</style>

<script>
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
    components: {
        Navbar,
        Footer,
        CoolLightBox
    },

    data () {
        return {
            filmes: [
                'catalogo/2020-12-08/01.jpg',
                'catalogo/2020-12-08/02.jpg',
                'catalogo/2020-12-08/03.jpg',
                'catalogo/2020-12-08/04.jpg',
                'catalogo/2020-12-08/05.jpg',
                'catalogo/2020-12-08/06.jpg',
                'catalogo/2020-12-08/07.jpg',
                'catalogo/2020-12-08/08.jpg',
                'catalogo/2020-12-08/09.jpg',
                'catalogo/2020-12-08/10.jpg',
                'catalogo/2020-12-08/11.jpg',
                'catalogo/2020-12-08/12.jpg',
                'catalogo/2020-12-08/13.jpg',
                'catalogo/2020-12-08/14.jpg',
                'catalogo/2020-12-08/15.jpg',
                'catalogo/2020-12-08/16.jpg',
                'catalogo/2020-12-08/17.jpg',
                'catalogo/2020-12-08/18.jpg',
                'catalogo/2020-12-08/19.jpg',
            ],
            index: null
        }
    },

}
</script>